import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export default function LanguageSwitcher() {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const current = i18n.language;
        const next = current === 'ru' ? 'uz' : current === 'uz' ? 'en' : 'ru';
        i18n.changeLanguage(next);
    };

    const labels = {
        ru: 'RU',
        uz: 'UZ',
        en: 'EN'
    };

    return (
        <button
            onClick={toggleLanguage}
            className="flex items-center text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors"
            title="Switch Language"
        >
            <Globe className="w-4 h-4 mr-1" />
            <span>{labels[i18n.language] || 'RU'}</span>
        </button>
    );
}
